export interface Portal {
  name: string;
  path: string;
  icon: string;
}

export const PORTALS: Portal[] = [
  {
    name: 'Tổng quan',
    path: '/dashboard',
    icon: '/icons/portal-dashboard.svg',
  },
  {
    name: 'HRM',
    path: '/hr',
    icon: '/icons/portal-hr.png',
  },
  {
    name: 'Dự án',
    path: '/task',
    icon: '/icons/portal-task.png',
  },
  {
    name: 'Quản trị hệ thống',
    path: '/phan-quyen',
    icon: '/icons/portal-admin.svg',
  }
];

export const getCurrentPortal = (pathname: string): Portal | null => {
  return PORTALS.find(portal => pathname.startsWith(portal.path)) || null;
};
